import { SetStateAction } from "react";
import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import { createIpTable } from "../functions/createIpTable";
import { getInputFormat } from "../functions/getInputFormat";

const writeUserInputInfo = ({
  t,
  modalData,
  windowValues,
  updateWindowValue,
  packInputFormat,
  packUpdateWindow,
}: stdObject) => {
  return "info" in windowValues
    ? modalData.codes?.map((v: string) => {
        const codeBase =
          v.length === 6 && v.endsWith("USU")
            ? v.substring(0, v.length - 3)
            : v;
        return {
          label: t(`c.${codeBase}`),
          code: v,
          value: windowValues.info[v],
          tabId: 0,
          ...getInputFormat(codeBase, packInputFormat),
          ...(v === "WCOUSU" ? { type: "passwordInput" } : {}),
          style: { width: 300 },
          onChange: (e: { target: { value: SetStateAction<string> } }) =>
            updateWindowValue({
              key: "info",
              code: v,
              value: [
                "ACTIVO",
                "LOGUSU",
                "MULUSU",
                "BLOUSU",
                "WEB",
                "DWNUSU",
              ].includes(v)
                ? Number(e.target.value)
                  ? 0
                  : 1
                : e.target.value,
              ...packUpdateWindow,
            }),
        };
      })
    : [];
};

export const userInfoModal = ({
  t,
  modalData,
  windowValues,
  setWindowValues,
  updateWindowValue,
  packInputFormat,
  packUpdateWindow,
  saveUserInfo,
  closeMsg,
}: stdObject) => {
  return {
    title: modalData.title,
    mainColor: modalData.mainColor,
    blocked: true,
    tabs: [
      { code: 0, label: t("p.info") },
      { code: 1, label: t("p.email") },
      { code: 2, label: t("p.ip") },
    ],
    inputs: writeUserInputInfo({
      t,
      modalData,
      windowValues,
      updateWindowValue,
      packInputFormat,
      packUpdateWindow,
    }),
    tableTab: 2,
    table: createIpTable({
      t,
      windowValues,
      setWindowValues,
    }),
    tableStyle: {
      maxHeight: 400,
      overflow: "auto",
      borderRadius: 0,
      border: "none",
    },
    buttons: [
      {
        label: modalData.id === "" ? t("p.create") : t("p.save"),
        onClick: saveUserInfo,
        color: colors.green,
      },
      // modalData.id > 0
      //   ? {
      //       label: t("p.delete"),
      //       onClick: () => deleteData(),
      //       color: colors.red,
      //     }
      //   : null,
      {
        label: t("p.cancel"),
        onClick: closeMsg,
        color: colors.darkGrey,
      },
    ],
  };
};
